// extracted by mini-css-extract-plugin
export default {"guest-artist-card-image":"GRD3rEbEGcpzcuVqSeBa","title":"_3m8ZCGvqssiYxFN4R8xw","copy":"sb3GRoW1kc1VOP8GNxAx","content":"sgOwnmi7DwVwE_T1K8B4"};